import React from 'react';
import PropTypes from 'prop-types';

import CustomizePaymentTarget from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePaymentTarget.jsx';
import TaxesIncluded from 'payment-calculator-v25/components/TaxesIncluded/TaxesIncluded.jsx';

import { PurchaseMethodsV25, PaymentOptionsMetadata, Quote } from '@sm360/widget-commons-vehicle';

import 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CustomizePayment/customizePayment.scss';

const CustomizePayment = ({
    purchaseMethods,
    updateTargetPayment,
    selectPaymentFrequency,
    paymentOptionsMetadata,
    quote,
    config,
}) => {
    return (
        <section className="new-customize-payment">
            <CustomizePaymentTarget
                purchaseMethods={purchaseMethods}
                onTargetPaymentSlide={updateTargetPayment}
                onPaymentFrequencyClick={selectPaymentFrequency}
                paymentOptionsMetadata={paymentOptionsMetadata}
                quote={quote}
                config={config}
            />
            <TaxesIncluded purchaseMethods={purchaseMethods} />
        </section>
    );
};

CustomizePayment.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    paymentOptionsMetadata: PropTypes.arrayOf(PropTypes.instanceOf(PaymentOptionsMetadata.PaymentOptionsMetadataModel))
        .isRequired,
    updateTargetPayment: PropTypes.func.isRequired,
    selectPaymentFrequency: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
};

CustomizePayment.displayName = 'CustomizePayment';

export default CustomizePayment;
